import SearchGroup from './SearchGroup'

export default SearchGroup
